import dayjs from 'dayjs'

function formatForApi(date) {
  return dayjs(date).format('YYYY-MM-DD')
}

export default formatForApi
